import React from "react";

export const formatCommission = (c) =>
    c?.commissionType === "flat" ? `₹${c.commissionValue}` : `${c?.commissionValue ?? 0}%`;

// One row per service on a booking (primary and, if set, secondary). Each row
// shows the provider's default commission for that category and lets the admin
// override it for this booking only.
//
// `services`: [{ categoryId, name, share, defaultEntry }]
// `value`:    { [categoryId]: { commissionType, commissionValue } } — only
//             overridden services have a key.
const CommissionOverrideFields = ({ services, value, onChange, disabled }) => {
    const setRow = (categoryId, row) => {
        const next = { ...value };
        if (row) next[categoryId] = row;
        else delete next[categoryId];
        onChange(next);
    };

    return (
        <div className="space-y-2">
            {services.map((s) => {
                const row = value[s.categoryId];
                return (
                    <div
                        key={s.categoryId}
                        className="flex flex-wrap items-center gap-2 text-sm"
                    >
                        <span className="min-w-[10rem] font-medium text-gray-800">
                            {s.name}
                            {s.share != null && (
                                <span className="font-normal text-gray-500"> · ₹{s.share}</span>
                            )}
                        </span>
                        <span className="text-xs text-gray-500">
                            Default: {s.defaultEntry ? formatCommission(s.defaultEntry) : "—"}
                        </span>
                        <label className="flex items-center gap-1 text-gray-700">
                            <input
                                type="checkbox"
                                disabled={disabled}
                                checked={!!row}
                                onChange={(e) =>
                                    setRow(
                                        s.categoryId,
                                        e.target.checked
                                            ? {
                                                  commissionType:
                                                      s.defaultEntry?.commissionType || "percent",
                                                  commissionValue: String(
                                                      s.defaultEntry?.commissionValue ?? ""
                                                  ),
                                              }
                                            : null
                                    )
                                }
                            />
                            Override
                        </label>
                        {row && (
                            <>
                                <select
                                    className="rounded border border-gray-300 p-1"
                                    disabled={disabled}
                                    value={row.commissionType}
                                    onChange={(e) =>
                                        setRow(s.categoryId, {
                                            ...row,
                                            commissionType: e.target.value,
                                        })
                                    }
                                >
                                    <option value="percent">%</option>
                                    <option value="flat">₹ flat</option>
                                </select>
                                <input
                                    type="number"
                                    min="0"
                                    step="any"
                                    placeholder="Commission"
                                    className="w-24 rounded border border-gray-300 p-1"
                                    disabled={disabled}
                                    value={row.commissionValue}
                                    onChange={(e) =>
                                        setRow(s.categoryId, {
                                            ...row,
                                            commissionValue: e.target.value,
                                        })
                                    }
                                />
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default CommissionOverrideFields;
